/**
 * Is this visitor signed in / identified? The one signal behind "no sign-in buttons" and "the pre-chat
 * only asks for what is still unknown". A verified handshake (`kind: identified`: host JWT / HMAC /
 * Google / passkey, or the dashboard preview's signed-in operator) or the session answer's `SIGNED_IN`
 * (the reliable cold-start signal). The private `audienceOverride.visitors` (dashboard preview) decides
 * in both directions so "Preview as Anonymous / Signed in" flips live.
 */
export function isIdentifiedVisitor(opts: {
  verified: boolean;
  sessionVisitors: "ANONYMOUS" | "SIGNED_IN" | null | undefined;
  override?: "ANONYMOUS" | "SIGNED_IN" | null;
}): boolean {
  if (opts.override) return opts.override === "SIGNED_IN";
  return opts.verified || opts.sessionVisitors === "SIGNED_IN";
}
